import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TwcPopupOptions } from '@topcon/twc-angular';

import { ProjectType } from '@mirage-projects/cw-models';

import { CreateProjectService } from '../../services/create-project.service';

@Component({
    templateUrl: './create-project-dialog.component.html',
    standalone: false,
})
export class CreateProjectDialogComponent implements OnInit, OnDestroy {
    projectType?: ProjectType;
    titlePopupProject = 'CREATE_PROJECT.TITLE';
    popupOptions!: TwcPopupOptions | undefined;
    onDestroy$: Subject<void> = new Subject();
    couldShowCreateComponent = false;
    constructor(private createProjectService: CreateProjectService) {}

    ngOnInit(): void {
        this.createProjectService.openDialog$.pipe(takeUntil(this.onDestroy$)).subscribe(({ projectType, options }) => {
            this.popupOptions = options;
            if (projectType) {
                this.openDialog(projectType);
            }
        });
    }

    openDialog(projectType: ProjectType): void {
        this.projectType = projectType;
        switch (projectType) {
            case ProjectType.COLLAGE_TYPE:
                this.titlePopupProject = 'CREATE_PROJECT.TITLE';
                break;
            case ProjectType.SCAN:
                this.titlePopupProject = 'CREATE_PROJECT.TITLE_SCANTYPE';
                break;
            default:
                break;
        }
        this.couldShowCreateComponent = true;
    }

    onClosePopupProject(): void {
        this.projectType = undefined;
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}
